const schema = {
  'title': '修改送餐地址',
  'type': 'object',
  'required': [],
  'properties': {
    'address': {
      'title': '',
      'type': 'object',
    },
  },
};

export default schema;
